import React, { useReducer } from "react";
import axios from "axios";
import AuthContext from "./authContext";
import authReducer from "./authReducer";
import setAuthToken from "../../utils/setAuthToken";
import {
  USER_LOADED,
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  CLEAR_ERRORS,
  AUTH_OK
} from "../types";

const AuthState = props => {
  const initialState = {
    token: localStorage.getItem("token"),
    isAuthenticated: null,
    loading: true,
    error: null
  };

  const [state, dispatch] = useReducer(authReducer, initialState);

  // Load User
  const loadUser = async () => {
    if (localStorage.token) {
      setAuthToken(localStorage.token);
    }

    try {
      const res = await axios.get(
        process.env.REACT_APP_API_URL + "/api/authenticate"
      );

      const resPermission = await axios.get(
        process.env.REACT_APP_API_URL + "/api/authenticate/permission"
      );

      dispatch({ type: USER_LOADED, payload: res.data, permission: resPermission.data });
    } catch (err) {
      dispatch({ type: AUTH_ERROR });
    }
  };

  // Login User
  const login = async formData => {
    const config = {
      headers: {
        "Content-Type": "application/json"
      }
    };

    try {
      const res = await axios.post(
        process.env.REACT_APP_API_URL + "/api/authenticate",
        formData,
        config
      );
      dispatch({
        type: LOGIN_SUCCESS,
        payload: res.data
      });

      await loadUser();
    } catch (err) {
      dispatch({
        type: LOGIN_FAIL,
        payload: err.response.data.msg
      });
    }
  };

  // Logout
  const logout = () => dispatch({ type: LOGOUT });

  // Clear Errors
  const clearErrors = () => dispatch({ type: CLEAR_ERRORS });

  // Check IsAuthenticated
  const checkAuth = () => {
    if (localStorage.token) {
      setAuthToken(localStorage.token);
    }

    if (localStorage.getItem("user") && localStorage.getItem("user") !== "undefined" && localStorage.token) {
      dispatch({ type: AUTH_OK });
    } else {
      dispatch({ type: AUTH_ERROR });
    }
  };

  return (
    <AuthContext.Provider
      value={{
        token: state.token,
        isAuthenticated: state.isAuthenticated,
        loading: state.loading,
        user: state.user,
        error: state.error,
        loadUser,
        login,
        logout,
        clearErrors,
        checkAuth
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthState;
